import React, { Component } from 'react';
import { Spin, Table, Tooltip, Button, Card, Icon, Modal, Select, DatePicker } from 'antd';
import { openNotification } from '../../util/notificaciones';
import { ShowMenuItem } from '../../util/ShowMenuItem';
import InventarioRequest from '../../services/Inventario';
import DetallesSAP from './DetallesSAP';
import moment from 'moment'
import 'moment/locale/es';
import { roles } from '../../util/Roles';
import Timer from '../Timer/Timer';
import { esBarras, getSegmento } from '../../util/generics';
moment.locale('es')
const rol = localStorage.getItem("role")?.split(",");
const { confirm } = Modal;

/**
 * Clase para ver el proceso historico de inventario
 */
export default class HistoricoPendienteSAP extends Component {
    state = {
        arrHistoricoInventario: [],
        cargando: false,
        scroll: { x: 1250, y: 470 },
        paginacion: {},
        paginaSiguiente: 1,
        fecha:{}
    }

    /**
     * Comportamiento del componente al mostrar el historico de inventarios
     */
    componentDidMount = () => {
        let state = { ...this.state };
        const segmento = getSegmento()
        if(!ShowMenuItem([roles.Admin]) || !segmento || esBarras()){
            const location = {
                pathname: "/",
            }
            this.setState(state, this.props.history.push(location))
        } else {
            this.setState({ cargando: true }, () => {
                InventarioRequest.ListarInventarioPendienteSAP(this.props.match.params.esExterno).then(response => {
                    state.paginacion = {
                        current: 1,
                        total: response.data.count,
                        onChange: this.handlePaginaChange,
                        pageSize: 100,
                        showTitle: false
                    }
                    response.data.results.find((item) => {
                        item.Fecha2 = new Date(item.Fecha);
                        item.Fecha2.setHours(item.Fecha2.getHours() + 7);
                    });
                    state.cargando = false;
                    state.arrHistoricoInventario = response.data.results;
                    this.setState(state)
                }).catch(err => {
                    this.setState({ cargando: false });
                    openNotification(
                        "Ha ocurrido un error al listar los inventarios.",
                        "Error"
                    )
                })
            })
        }
    }

    componentWillReceiveProps(props) { }

    /**
     * Función que se ejecuta cuando se da clic en página siguiente
     * @param: paginaSiguiente. valor de la página siguiente
     * @return: nada. se establece un nuevo valor para la el texto a filtrar.
     */
    handlePaginaChange = (paginaSiguiente) => {
        let state = { ...this.state };
        state.paginaSiguiente = paginaSiguiente
        this.setState({ cargando: true }, () => {
            InventarioRequest.ListarInventarioPendienteSAP(this.props.match.params.esExterno).then(response => {
                state.paginacion = {
                    current: paginaSiguiente,
                }
                state.cargando = false;
                state.arrHistoricoInventario = response.data.results
                this.setState(state)
            }).catch(err => {
                this.setState({ cargando: false });
                openNotification(
                    "Ha ocurrido un error al listar el histórico del drive seleccionado.",
                    "Error"
                )
            })
        })
    }

    /**
     * Función para esconder modal de detalle de inventario
     * @param: value. true o false
     * @return: nada
     */
    esconderModal = (value) => {
        let state = { ...this.state }
        state.visibleSAP = false;
        state.objInventario = null;
        this.setState(state, () => {
            if (value) this.componentDidMount();
        })
    }

    deleteInv = (record) => {
        let state = { ...this.state };
        this.setState({ cargando: true }, () => {
            InventarioRequest.EliminarInventarioPendienteSAP(this.props.match.params.esExterno, record.id).then(response => {
                state.paginacion = {
                    current: 1,
                    total: response.data.count,
                    onChange: this.handlePaginaChange,
                    pageSize: 100,
                    showTitle: false
                }
                response.data.results.find((item) => {
                    item.Fecha2 = new Date(item.Fecha);
                    item.Fecha2.setHours(item.Fecha2.getHours() + 7);
                });
                state.cargando = false;
                state.arrHistoricoInventario = response.data.results;
                this.setState(state)
            }).catch(err => {
                this.setState({ cargando: false });
                console.log(err)
                openNotification(
                    "Ha ocurrido un error al eliminar el inventario. Favor de intentarlo más tarde",
                    "Error"
                )
            })
        })
    }

    showFormSAP = (type, _, record) => {
        this.setState({ typeForm: type, objInventario: record, visibleSAP: true })
    }

    getStatus(value){
        if(value === 1){
            //state.fontColor = "#F1C40F";
            return "Borrador"
        } else if(value === 2){
            //state.fontColor = "#A93226";
            return "Validar Reconteo"
        } else if(value === 3){
            //state.fontColor = "#A93226";
            return "Procesando"
        } else if(value === 4){
            //state.fontColor = "#A93226";
            return "Pendiente SAP"
        } else {
            //state.fontColor = "#1E8449";
            return "Finalizado"
        }

    }
    
    showConfirm = (value) => {
        confirm({
            title: 'Confirmar Eliminar',
            content: <div><b>¿Está seguro de eliminar este registro?</b></div>,
            okText: 'Aceptar',
            cancelText: 'Cancelar',
            okButtonProps: {
                id: 'boton-aceptar-confirmacion-capturar-inventario-form',
            },
            cancelButtonProps: {
                id: 'boton-cancelar-confirmacion-capturar-inventario-form',
            },
            onOk: () => {
                console.log("ELIMINAR", value)
                this.deleteInv(value)
            },
        });
    }

    render() {
        const columnasInventario = [
            {
                title: "Fecha y hora de captura",
                dataIndex: "Fecha2",
                key: "Fecha2",
                render: fecha => {
                    return (
                        <span>
                            {moment(fecha).format("DD/MM/YYYY, h:mm a")}
                        </span>
                    )
                }
            },
            {
                title: "Drive",
                dataIndex: "sitio",
                key: "sitio",
                render: sitio => {
                    return (
                        <span>
                            {sitio}
                        </span>
                    )
                }
            },
            {
                title: "Estado",
                dataIndex: "Estatus",
                key: "Estatus",
                render: (value) => {
                    return (
                        <span style={{fontWeight: "bold", color: value == 1 ? '#F1C40F' : (value == 2 ? '#FA8007' : (value == 3 ? '#E74C3C' : (value == 4 ? '#E74C3C' : '#239B56')))}}> {this.getStatus(value)}</span>
                    )
                }
            },
            {
                title: "Inventario Número",
                dataIndex: "Refencia",
                key: "Refencia",
                render: Refencia => {
                    return (
                        <span>
                            {Refencia}
                        </span>
                    )
                }
            },
            {
                title: 'Acciones',
                dataIndex: 'Acciones',
                key: 'Acciones',
                render: (value, record) => (
                    <div>
                        <span style={{ marginRight: 5 }}>
                            <Tooltip placement="top" title={"Eliminar"}>
                                <Button icon="delete" className="btnEditar" onClick={() => this.showConfirm(record)}></Button>
                            </Tooltip>
                        </span>
                        <span style={{ marginRight: 5 }}>
                            <Tooltip placement="top" title={"Detalles SAP"}>
                                <Button icon="warning" className="btnEditar" onClick={() => this.showFormSAP('detalle', value, record)}></Button>
                            </Tooltip>
                        </span>
                    </div>
                )
            }
        ]
        return (
            <Card id="ParentSize"
            title={this.props.match.params.esExterno == 'true' ? 'Pendiente SAP' : 'Histórico de inventario interno'}
            >
                <div className="panel-block">
                    <Spin
                        tip="Cargando..."
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                        spinning={this.state.cargando}
                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}>
                        <Table size="small"
                            locale={{ emptyText: 'No se han encontrado resultados' }}
                            rowKey={(_, index) => index}
                            columns={columnasInventario}
                            dataSource={this.state.arrHistoricoInventario}
                            pagination={this.state.paginacion}
                            scroll={{ y: 600 }}
                        />
                    </Spin>
                </div>
                <DetallesSAP
                    esconderModal={this.esconderModal}
                    visible={this.state.visibleSAP}
                    type={this.state.typeForm}
                    inventario={this.state.objInventario}
                    esExterno={this.props.match.params.esExterno}
                />
            </Card>
        )
    }
}